import * as React from 'react';

interface PreventToolbarHiddenContextValue {
  preventToolbarHidden: boolean;
  setPreventToolbarHidden: (prevent: boolean) => void;
}

export const PreventToolbarHiddenContext =
  React.createContext<PreventToolbarHiddenContextValue>(null);

export const usePreventHiddenToolbar = () => React.useContext(PreventToolbarHiddenContext);
